<template>
  <div>
    <v-container grid-list-xl fluid>
      <h2>Obrigado! Seu arquivo será baixado na sequencia</h2>
      <v-layout row wrap>
        <v-flex xs12 sm6 offset-sm3>
          <v-card flat>
            <v-img src="../../static/LogoVitalab.png" aspect-ratio="3"></v-img>
            <v-card-actions>
              <a href="http://labvitalab.com.br">Acesse nosso site e descubra mais!</a>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {
  },
  methods: {
    home() {
      this.$router.push(`/${this.$store.getters.home_page}`);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
  color: #0f5636;
  text-align: center;
  margin-top: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/Obrigado.vue